<template>
<div class="basis-page-cls" v-loading="loading">
        <section class="basis-cls_table">
            <div class="header">
                <span class="title">成员管理</span>
                <div class="btns">
					<el-popover
						placement="bottom-end"
						width="610"
						v-model="visible">
							<el-transfer
								class="transfer"
								:titles="['可选用户','已选用户']"
								filterable
								:filter-method="filterMethod"
								:props="{key:'userId',label: 'nickname'}"
								v-model="userIds"
								:data="userList">
							</el-transfer>
						<br>
						<div style="text-align: right;">
							<el-button @click.stop="visible = false" size="mini" type="text" >取消</el-button>
							<el-button @click.stop="handelCreate" :loading="loading" type="primary" size="mini">确定</el-button>
						</div>
						<el-button slot="reference" type="primary" size="mini" icon="el-icon-circle-plus-outline" class="right">添加成员</el-button>
					</el-popover>
                </div>
            </div>
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList">
					<template v-slot:right="{ row }">
						<el-dropdown @command="(command) => {return handleUpdate(command, row)}" trigger="click">
							<span class="el-dropdown-link">
								{{row.right == '6' ? '管理' : '只读'}} <i class="el-icon-caret-bottom"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="6">管理</el-dropdown-item>
								<el-dropdown-item command="1">只读</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</table-pagination>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Users from './Users';
export default {
	components: {Users},
	props: ['row'],
	computed: {
		...mapGetters([
			'userInfo'
		])
	},
	data() {
		return {
			userIds: [],
			userList: [],
			visible: false,
			resourceType: '',
			column: [
				{ label: '成员', prop: 'userName' },
				{
                    label: '权限',
                    prop: 'right',
					slotScope: true
                },
				{
                    label: '操作',
                    prop: 'cation',
                    align: 'center',
                    width: 80,
                    fixed: 'right',
                    render: (h, scope) => {
						return (
							<el-button 
								type="danger"
								size="mini"
								onClick={() => this.handleDelete(scope.row)}>
								删除
							</el-button>
						)
                    }
                }
            ],
			listQuery: {
				projectId: '',
				id: '',
				pageNum: 1,
				pageSize: 10
			},
			list: [],
			total: 0,
			loading: false
		}
	},
	watch: {
		visible: {
			handler(val) {
				if(val) {
					this.$api.getSystemSkillGroupAllUsers({
						brandList:this.userInfo.brandList,
					}).then(response => {
						if(response.errcode != 0) {
							return;
						}
						this.userList = response.data;
					});
				}
			},
			immediate:true,
			deep: true
		},
	},
	async created() {
		await this.getList();
		// await this.getRoleUserList();
	},
	methods: {
		getList() {
			this.loading = true;
			this.listQuery.projectId = this.row.projectId;
			this.listQuery.id = this.row.id;
			this.$api.apiPostKnowledgeSelectResourceUserList(this.listQuery).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.list = response.data?.rows ? response.data?.rows : [];
				this.total = response.data?.total ? response.data?.total : 0;
				this.loading = false;
				this.visible = false;
			});
		},
		handelCreate() {
			if(this.userIds.length === 0) {
				this.$message({
					message: '请选择成员',
					type: 'warning'
				});
				return;
			}
			this.loading = true;
			this.$api.apiPostKnowledgeResourceAddResourceUser({
				resourceId: this.row.id,
				userIds: this.userIds,
				right: 1
			}).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.getList();
			});
		},
		handleUpdate(command, row) {	
			if(command == row.right) return;
			this.$confirm(`是否切换此成员为 ${command == '1' ? '只读' : '管理'} ？`,"系统提示",{
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.$api.apiPostKnowledgeResourceEditResourceUser({
					projectId: row.projectId,
					id: row.rightId,
					right: command
				}).then(response => {
					if(response.errcode != 0) return;
					this.getList();
				});
			}).catch(() => {});
		},
		handleDelete(row) {
			this.$confirm(`是否删除 ${row.userName}？`,"系统提示",{
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.$api.apiPostKnowledgeResourceDeleteResourceUser({
					projectId: row.projectId,
					id: row.rightId
				}).then(response => {
					if(response.errcode != 0) return;
					this.getList();
				});
			}).catch(() => {});
		},
		getRoleUserList() {
            this.$api.getRoleUserRoleList().then(res => {
				if(res.errcode != 0) return false;
                this.userList = res.data.userList
                this.userListSelected = res.data.userListSelected
            })
        },
		filterMethod(query, item) {
			return item.nickname.indexOf(query) > -1;
        },
	}
}
</script>